import { render, staticRenderFns } from "./RecruitmentConfiguration.vue?vue&type=template&id=615fb540&scoped=true&"
import script from "./RecruitmentConfiguration.vue?vue&type=script&lang=js&"
export * from "./RecruitmentConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentConfiguration.vue?vue&type=style&index=0&id=615fb540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615fb540",
  null
  
)

export default component.exports